import BootstrapDatepickerFormatValidator from './bootstrapDatepickerFormatValidator.directive';
import BootstrapDatepickerMinMaxValidator from './bootstrapDatepickerMinMaxValidator.directive';
import GooglePlacesModule from './google-places/google-places-module';
import RangeSliderModule from './range-slider/range-slider-module';
import PriceRangeModule from './price-range/price-range-module';
import ChecklistModelDecorator from './checklistModel.decorator';
import CursorPosition from './cursorPosition.directive';
import DropdownSelect from './dropdownSelect.directive';
import FallbackSrc from './fallback-src-directive';
import ScaleOnLoad from './scale-on-load-directive';
import FormSubmit from './formSubmit.directive';
import FormWarningMessenger from './ktFormWarningMessenger';
import NameValidator from './ktNameValidator';
import EmailValidator from './ktEmailValidator';
import L10n from './l10n.directive';
import OffClick from './offClick.directive';
import RecentSearches from './recentSearches.directive';
import ResultsDropdownFilter from './resultsDropdownFilter.directive';
import TimeRange from './timeRange.directive';
import Typeahead from './typeahead/typeahead-directive';
import MightyDatepicker from './mighty-datepicker-directive';
import DropdownSelectValidator from './dropdown-select-validator';
import AlertService from './message-alert/alert-service';
import AlertContainerDirective from './message-alert/alert-container-directive';
import FiltersSubgroup from './filters-subgroup-directive';
import PreventSecondClick from './prevent-second-click';
import LoadingProgressbarModule from './loading-progressbar/loading-progressbar-module';
import FlightSearchDepartDateValidator from './kt-flight-search-depart-date-validator';
import ClickOutside from './clickOutside.directive';
import DropdownKt from './dropdown-kt.directive';
import DropdownHtmlKT from './dropdown-kt-html.directive';

const MODULE_NAME = 'App.Directives';
const module = angular
    .module(MODULE_NAME, [
        RangeSliderModule,
        PriceRangeModule,
        GooglePlacesModule,
        LoadingProgressbarModule,
    ])
    .directive('ktTypeahead', Typeahead)
    .directive('ktMightyDatepicker', MightyDatepicker)
    .directive('ktDropdownSelectValidator', DropdownSelectValidator)
    .directive('ngDateFormat', BootstrapDatepickerFormatValidator)
    .directive('ngMinMax', BootstrapDatepickerMinMaxValidator)
    .directive('cursorPosition', CursorPosition)
    .directive('dropdownSelect', DropdownSelect)
    .directive('fallbackSrc', FallbackSrc)
    .directive('ktScaleOnLoad', ScaleOnLoad)
    .directive('formSubmit', FormSubmit)
    .directive('ktFormWarningMessenger', FormWarningMessenger)
    .directive('ktNameValidator', NameValidator)
    .directive('ktEmailValidator', EmailValidator)
    .directive('ktFlightSearchDepartDateValidator', FlightSearchDepartDateValidator)
    .directive('l10n', L10n)
    .directive('offClick', OffClick)
    .directive('recentSearches', RecentSearches)
    .directive('resultsDropdownFilter', ResultsDropdownFilter)
    .directive('timeRange', TimeRange)
    .directive('ktAlertContainer', AlertContainerDirective)
    .directive('ktFiltersSubgroup', FiltersSubgroup)
    .directive(PreventSecondClick.DIRECTIVE_NAME, PreventSecondClick)
    .directive('clickOutside', ClickOutside)
    .directive('dropdownKt', DropdownKt)
    .directive('dropdownHtmlKt', DropdownHtmlKT)
    .service('ktAlert', AlertService)
    .config(ChecklistModelDecorator);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/directives/directives-module.js